import Model, { attr, belongsTo } from "@ember-data/model";

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    creator: Creator;
  }
}

export default class Creator extends Model {
  @attr("string") declare firstName: string;
  @belongsTo("journal-event", { async: true, inverse: null })
  journalEvent;
  @attr("string") declare lastName: string;

  get fullName(): string {
    const names: string[] = [];
    if (this.firstName) {
      // this is to handle composed first names, we capitalize the first letter of each word (separated by space or dash)
      const firstNameTitleized = this.firstName
        .toLowerCase()
        .replace(/(?:^|[\s-])\p{L}/gu, match => match.toUpperCase());
      names.push(firstNameTitleized);
    }
    if (this.lastName) {
      names.push(this.lastName.toUpperCase());
    }
    return names.join(" ");
  }

  get name(): string {
    return this.fullName;
  }
}
